import axios from 'axios'
import qs from 'qs'
import hex_md5 from 'js-md5';
import Vue from 'vue'
import store from '@/store'

const appkey = "703e2d909f8f"
const appSecret = "ae2291c2"

const service = axios.create({
	 //baseURL: "http://81.69.219.18:8889",

	 //baseURL: "http://localhost:51837",
	 // baseURL:"http://jxbs.info:9988",
	 baseURL:'http://36.22.191.66:4005',
	 // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	//timeout: 5000 // request timeout
})

service.interceptors.request.use(
	config => {
		if(!config.data){
			config.data={}
		}
		if (!!store.state.token) {
			config.data.token = store.state.token
		}
		config.data.appkey = appkey
		config.data.t = (new Date()).valueOf();
		config.data.sign = getSign(config.data);
		if (config.method === 'get') {
			config.params = config.data
			config.data = undefined
		}else{
			config.data = qs.stringify(config.data)
		}

		// do something before request is sent
		return config
	}
)
service.interceptors.response.use(
	response => {
		const res = response.data
		return res
	}
)
var getSign = function(parms) {
	var keys = [];
	for (var key in parms) {
		if (key != "sign" && key != "appkey") {
			keys.push(key)
		}
	}
	keys.sort();
	var sb = ""
	for (var i in keys) {
		sb += (keys[i] + "=" + parms[keys[i]]);
		sb += ("&");
	}
	sb = sb.substr(0, sb.length - 1);
	sb += "#" + appSecret;
	sb = encodeURIComponent(sb);
	sb = sb.toLowerCase();
	sb = hex_md5(sb);
	return sb;
}
export default service
